import styles from './FieldWasChanged.module.scss';

type Props = {
  text: string;
};

export const FieldWasChangedLabel = ({ text }: Props) => {
  return (
    <div className={styles.EmptySearch}>
      <span className={styles.InfoIcon}></span>
      <span className={styles.InformationSupportText}>{text}</span>
    </div>
  );
};
